<template>
  <div class="privileges-management-container p-4">
    <!-- Title -->
    <!-- <h3 class="text-center mb-4">إدارة الصلاحيات</h3> -->
    <h2 class="text-center label"> قائمة الموظفين </h2>


    <div class="table-responsive">
      <!-- <h2 class="text-center label"> قائمة الموظفين </h2> -->
      <table class="main-table table table-bordered">
        <thead>
          <tr class="">
            <th class="">
              الرقم الوظيفي
            </th>
            <th class="">
              الاسم
            </th>
            <th class="">
              الصفة
            </th>
            <th class="">
              المركز الجمركي
            </th>
            <th class="">
              حالة الحساب
            </th>
            <th class="">
              حركة المستخدم
            </th>
            <th class="">
              التحكم
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(user, i) in users" :key="i" class="">
            <td>
              <router-link class="link link-dark" :to="'/admin/profile/' + user.id">
                {{ user.empNo }}
              </router-link>
            </td>
            <td>
              <router-link class="link link-dark" :to="'/admin/profile/' + user.id">
                {{ user.fullname }}
              </router-link>
            </td>
            <td :class="(user.groupId == 1) ? 'fw-bold' :((user.groupId == 6)? 'text-black-50' :'')">
              {{ getGroups.find(e => e.id == user.groupId)?.groupName }}
            </td>
            <td>
              {{ getDeparts.find(e => e.id == user.departId)?.name }}
            </td>
            <td :class="user.isActive ? 'text-success' : 'text-danger'">
              {{ (user.isActive) ? "مُفعّل" : "موقوف" }}
            </td>
            <td>
              <router-link :to="'/admin/reports/useractivities/' + user.id" type="button" :class="'btn btn-secondary ' + ((!getUser?.privs.includes('userActivities')) ? 'disabled ' : '')">النشاطات</router-link>
            </td>
            <td class="">
              <button type="button" :class="'mx-1 btn btn-secondary ' + ((user.groupId == 1 && getUser?.id != user.id)? 'disabled ' : '') " @click="fetchUserPrivileges(user)">الصلاحيات</button>
              <button type="button" :class="'mx-1 btn btn-' + ((user.isActive) ? 'warning ' : 'success ') + ((user.groupId == 1)? 'disabled ' : '')"
                @click="activeOrBlock(user.id, ! user.isActive)">{{ (user.isActive) ? "تجميد" : "تفعيل" }}</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- User Privileges -->
    <div v-if="userPrivileges" class="card shadow-sm">
      <div class="card-header">
        <h5>صلاحيات المستخدم</h5>
      </div>
      <div class="card-body">
        <h5 class="text-center">{{ selectedUser.fullname }}</h5>
        <!-- User Group -->
        <div class="mb-3">
          <label for="user-group" class="form-label">مجموعة المستخدم</label>
          <select v-model="selectedGroup" id="user-group" class="form-select" @change="isGroupChanged = true">
            <option value="" :selected="true" disabled>الصفة الوظيفية</option>
            <option v-for="group in getGroups" :key="group.id" :value="group.id" >
              {{ group.groupName }}
            </option>
          </select>
        </div>

        <!-- Privileges -->
        <div>
          <h6>تحديد الصلاحيات:</h6>
          <div class="checkbox-columns">
            <div v-for="(priv, index) in allPrivileges" :key="priv.id" class="checkbox-column">
              <div v-if="index % 5 === 0 && index !== 0" class="col-12"></div> <!-- New column after 5 items -->
              <div class="form-check mb-2">
                <input type="checkbox" class="form-check-input" :id="'priv' + priv.id" :value="priv.id"
                  v-model="selectedPrivileges" />
                <label class="form-check-label" :for="'priv' + priv.id">
                  {{ priv.prevName }}
                </label>
              </div>
            </div>
          </div>
        </div>

        <!-- Save Button -->
        <button class="btn btn-success mt-3 w-100" @click="submitPrivsAndGroup">
          حفظ الصلاحيات
        </button>
      </div>
    </div>

    <!-- No User Selected Message -->
    <!-- <div v-else-if="selectedUser && !userPrivileges" class="alert alert-warning text-center">
      لم يتم العثور على أي بيانات للمستخدم.
    </div> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: "Privileges",
  // props: ["selectedUser"], // Accepts the user ID as a prop if needed
  data() {
    return {
      userPrivileges: null, // User's current privileges
      allPrivileges: [], // All available privileges
      groups: [], // All available groups
      selectedPrivileges: [], // Selected privileges for the user
      selectedGroup: "", // Selected group for the user
      isGroupChanged: false, // Selected group for the user
      users: [], // User ID to search privileges for
      selectedUser: "", // User ID to search privileges for
      statusClass: [
        "success",
        "danger",
      ]
    };
  },
  computed: {
    ...mapGetters(['getDeparts', 'getGroups', 'getUser'])
  },

  methods: {
    /** */
    ...mapActions([
      'fetchDeparts',
      'fetchGroups',
      'fetchUser',
    ]),
    /********************************/
    // Fetch all privileges and groups on component load
    async fetchAllOptions() {

      if (this.getDeparts.length == 0) {
        await this.fetchDeparts();
      }
      if (this.getGroups.length == 0) {
        await this.fetchGroups();
      }
      if (this.getUser.hasOwnProperty("empNo") == 0) {
        await this.fetchUser();
      }
      try {
        const [usersResponse, privilegesResponse] = await Promise.all([
          this.$axios.get("api/employee/user/getallusers"),
          this.$axios.get("api/employee/priv/getallprivileges"),
        ]);

        if (usersResponse.data.isSuccess) {
          this.users = usersResponse.data.users;
        }
        if (privilegesResponse.data.isSuccess) {
          this.allPrivileges = privilegesResponse.data.privileges;
        }
      } catch (error) {
        console.error("Error fetching privileges and groups:", error);
      }
    },

    // Fetch user privileges
    async fetchUserPrivileges(user) {
      this.selectedUser = user;
      if (!this.selectedUser.id) {
        this.$tempAlert("يرجى إدخال معرف المستخدم.");
        return;
      }
      this.isGroupChanged = false;

      try {
        const response = await this.$axios.post(`api/employee/priv/getuserprivileges`,
          { userId: this.selectedUser.id }
        );

        if (response.data.isSuccess) {
          this.userPrivileges = response.data.privileges;
          this.selectedGroup = response.data.groupId;
          this.selectedPrivileges = this.userPrivileges.map((priv) => priv.id);
        } else {
          this.userPrivileges = null;
          this.$tempAlert(response.data.msg || "فشل في جلب بيانات المستخدم.");
        }
      } catch (error) {
        console.error("Error fetching user privileges:", error);
        this.userPrivileges = null;
      }
    },

    // Save user privileges
    async saveUserPrivileges() {
      try {
        const response = await this.$axios.post(`api/employee/priv/setuserprivileges`, {
          userId: this.selectedUser.id,
          privileges: this.selectedPrivileges.map((id) => (id)),
        });

        if (response.data.isSuccess) {
          this.$tempAlert("تم تحديث الصلاحيات بنجاح.", "success");
        } else {
          this.$tempAlert(response.data.msg || "فشل في تحديث الصلاحيات.");
        }
      } catch (error) {
        console.error("Error saving user privileges:", error);
        this.$tempAlert("حدث خطأ أثناء حفظ الصلاحيات.");
      }
    },

    // Update user group
    async updateUserGroup() {
      if (!this.selectedGroup) return;

      try {
        const response = await this.$axios.post(`api/employee/priv/setusergroupId`, {
          userId: this.selectedUser.id,
          groupId: this.selectedGroup,
        });

        if (response.data.isSuccess) {
          this.$tempAlert("تم تحديث مجموعة المستخدم بنجاح.", "success");
        } else {
          this.$tempAlert(response.data.msg || "فشل في تحديث المجموعة.");
        }
      } catch (error) {
        console.error("Error updating user group:", error);
        this.$tempAlert("حدث خطأ أثناء تحديث المجموعة.");
      }
    },
    
    /** */
    submitPrivsAndGroup() {
      this.saveUserPrivileges();
      if (this.isGroupChanged) {
        this.updateUserGroup();
      }
    },
    // Update user group
    async activeOrBlock(userId, newStatus) {
      try {
        const response = await this.$axios.post(`api/employee/user/alterstatus`, {
          userId: userId,
          status: newStatus,
        });

        if (response?.data.isSuccess) {
          this.$tempAlert("تمت العملية بنجاح.", "success");
          this.users.find(e => e.id == userId).isActive = newStatus;
        } else {
          this.$tempAlert(response?.data.msg || "فشل في تحديث المجموعة.");
        }
      } catch (error) {
        console.error("Error updating user group:", error);
        this.$tempAlert("حدث خطأ أثناء الاتصال بالخادم.");
      }
    },
    /*****************/
  },
  created() {
    this.fetchAllOptions();
  },
};
</script>

<style scoped>
.privileges-management-container {
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.card {
  border-radius: 10px;
}

.form-check-label {
  cursor: pointer;
}

.alert {
  margin-top: 20px;
}

/* Style for the privilege checkboxes layout */
.checkbox-columns {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 15px;
}

.checkbox-column {
  display: flex;
  flex-direction: column;
}

.checkbox-column .form-check {
  margin-bottom: 8px;
}
</style>